import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0dfd042&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0dfd042')) {
      api.createRecord('b0dfd042', component.options)
    } else {
      api.reload('b0dfd042', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b0dfd042&", function () {
      api.rerender('b0dfd042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Filter/index.vue"
export default component.exports